import { secondaryNavigationStyles as styles } from "@iewc/Overrides/Widgets/Header/SecondaryNavigation";
import { colorStrings, mediaQueriesBP } from "@iewc/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.showInventoryLink = {
    css: css`
        margin-left: 0;
    `,
};

styles.showPricingLink = {
    css: css`
        margin-left: 0;
    `,
};

styles.currencyLink = {
    css: css`
        margin-left: 0;
    `,
};

styles.languageLink = {
    css: css`
        flex: 0 0 auto;
        margin-left: 0;
    `,
};

styles.warehousePickupLink = {
    css: css`
        flex: 0 1 auto;
        min-width: 30px;
        margin-left: 0;
    `,
};

styles.signInLink = {
    css: css`
        flex: 0 0 auto;
        margin-left: 0;
        color: ${getColor(colorStrings.primaryMain)};

        span {
            text-transform: none;
            margin: 0;
        }

        svg {
            color: ${getColor(colorStrings.primaryMain)};
            height: 18px;
            width: 18px;
        }
    `,
};

styles.navigationModeMenuLinks = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        gap: 20px;
    `,
};

styles.link = {
    typographyProps: {
        size: 14,
    },
};
